import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.54 6.705a1.6 1.6 0 0 1 .355 2.235l-12.8 17.6c-.276.38-.7.615-1.17.655s-.926-.135-1.256-.465l-6.4-6.4a1.602 1.602 0 0 1 2.266-2.265l5.075 5.075 11.7-16.085a1.6 1.6 0 0 1 2.235-.355z" })
});
export default SvgCheckRegularIcon;
